import "./job-postings.css";

document.addEventListener("DOMContentLoaded", () => {
  const el = document.querySelector(".element-jobpostings");

  const isLast = document.querySelector("main > article").lastElementChild === el;

  const observer = new ResizeObserver(() => {
    const content = el.querySelector(".element-content");
    let offset = content.offsetHeight * 1.75;

    if (isLast) {
      offset = el.offsetHeight;
      el.classList.add("is-last");
    }

    document.documentElement.style.setProperty("--job-postings-offset", `${offset}px`);
  });

  observer.observe(document.body);
});
